import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_EDGEAI_STATUS,
    REQUEST_EDGEAI_UPDATE,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import { EnableEdgeAI } from "userful-chronos-app-common-js/dist/models/eisenhower/edgeSetup";
import "./edgeMsgReciever";

export const requestStatusFromServer = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_EDGEAI_STATUS);
};

export const requestUpdateStatusToServer = (payload: EnableEdgeAI) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_EDGEAI_UPDATE, payload);
};
